export const tilesIds = {
  market: {
    pois: 'pois',
    cannibalization: 'cannibalization',
  },
} as const
